/**
 * Arabic Contact Translations
 * 联系页翻译模块 - 阿拉伯语
 * 
 * 包含联系表单、联系信息、地图等翻译
 */

import type { ContactTranslations } from '../../types';

export const arContact: ContactTranslations = {
  title: 'اتصل بنا',
  subtitle: 'نود أن نسمع منك.',
  header: {
    title: 'اتصل بنا',
    subtitle: 'نود أن نسمع منك.',
  },
  form: {
    firstName: 'الاسم الأول',
    lastName: 'الاسم الأخير',
    email: 'البريد الإلكتروني',
    interested: 'المنتج المهتم به',
    selectProduct: 'يرجى الاختيار',
    message: 'الرسالة',
    send: 'إرسال الرسالة',
    sending: 'جاري الإرسال...',
  },
  info: {
    headquarters: 'المقر الرئيسي',
    address: 'المبنى 25، حديقة وانيانغ للعلوم والتكنولوجيا، طريق تينغ وانغ رقم 26، بلدة تينغ جيانغ، مقاطعة ماوي، فوتشو، مقاطعة فوجيان، الصين',
    phoneSupport: 'الدعم الهاتفي',
    phone: '+86-15080458735',
    phoneHours: 'السبت-الخميس 9ص - 6م (GMT+8)',
    emailUs: 'راسلنا',
    sales: 's3@jinghui-tech.com',
    support: 's3@jinghui-tech.com',
    distributor: 'شبكة الموزعين',
    distributorDesc: 'نبحث عن موزعين عالميين. انضم إلينا لجلب التدفئة الخضراء إلى بلدك.',
  },
  success: {
    title: 'تم إرسال الرسالة!',
    desc: 'شكرًا لتواصلكم. سيقوم فريق المبيعات بالرد خلال 24 ساعة.',
    sendAnother: 'إرسال رسالة أخرى',
  },
};
